import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { LoginGuard } from './services/login.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'member',
    pathMatch: 'full'
  },
  {
    path: 'sys',
    loadChildren: () => import('./routes/sys/sys.module').then(m => m.SysPageModule)
  },
  {
    path: 'member',
    loadChildren: () => import('./routes/member/member.module').then(m => m.MemberPageModule),
    canActivate: [LoginGuard],

  },
  {
    path: 'common',
    canActivate: [LoginGuard],
    loadChildren: () => import('./routes/common/common.module').then(m => m.CommonPageModule)
  },
  {
    path: 'carstock',
    canActivate: [LoginGuard],
    loadChildren: () => import('./routes/carstock/carstock.module').then(m => m.CarstockPageModule)
  },
  {
    path: 'financia',
    canActivate: [LoginGuard],
    loadChildren: () => import('./routes/financia/financia.module').then(m => m.FinanciaPageModule)
  },
  {
    path: 'sysgate',
    canActivate: [LoginGuard],
    loadChildren: () => import('./routes/sys-gate/sys-gate.module').then(m => m.SysGatePageModule)
  },
  {
    path: 'a',
    loadChildren: () => import('./routes/a/a.module').then( m => m.APageModule)
  },
  {
    path: 'tempcar',
    loadChildren: () => import('./routes/tempcar/tempcar.module').then( m => m.TempcarPageModule),
    canActivate: [LoginGuard]
  },
  {
    path: 'yicard',
    loadChildren: () => import('./routes/yicard/yicard.module').then( m => m.YicardPageModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'jkyc',
    loadChildren: () => import('./routes/jkyc/jkyc.module').then( m => m.JkycPageModule)
  }
];
@NgModule({
  imports: [
    //PreloadAllModules
    RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
